import { Button, Card, Checkbox, Col, DatePicker, Radio, Row, Tooltip } from 'antd';
import React from 'react';
import strings from '../../eyeguide-localization/reports/string.filter';
import moment from 'moment';
import CustomFilter from './reports.customfilter';
import FilterList from './reports.filterlist';
import SessionStorage from '../../service/sessionstorage';

interface ICustomFilter {
    firstname: string | null;
    lastname: string | null;
    middlename: string | null;
    profileID: string | null;
    score: Array<any> | null;
    sport: string | undefined;
    level: string | undefined;
    gender: Array<any> | undefined;
    range: string | undefined;
}

interface IFilterProps {
    location: any;
    organizations: Array<any>;
    handleLoadCall: Function;
    customState: any;
    setParent: any;
    isPrivacyEnabled: boolean;
    isFailedTestFilterEnabled: boolean;
}

interface IfilterState {
    testRange: any;
    selectedOrgs: Array<any>;
    indeterminate: boolean;
    checkAll: boolean;
    collapsible: boolean;
    custom: ICustomFilter;
    customRange: any;
    reloadNeeded: boolean;    
    failedTestSelectedOpt:  Array<any>;
}

enum FailedTestOptions {
    SHOW_TEST = 1,
    SHOW_BASELINE = 2
}
class Filter extends React.Component<IFilterProps, IfilterState> {

    constructor(props: IFilterProps) {
        super(props);
        var meta = SessionStorage.getReportMeta(),
           check = meta && meta.isTestLoaded;
        this.state = {
            testRange: check ? meta.testRange : '',
            selectedOrgs: check ? meta.filter.rosterids : this.props.organizations.map((v: any) => v.rosterid),
            indeterminate:  false,
            checkAll: check ? false : true,
            collapsible: false,
            customRange: check && meta.testRange === 'custom' ? this.getCustomRange(meta) : [],
            custom: {
                firstname       : check && meta.filter.filter ? meta.filter.filter.firstname : null,
                lastname        : check && meta.filter.filter ? meta.filter.filter.lastname : null,
                middlename      : check && meta.filter.filter ? meta.filter.filter.middlename : null,
                profileID       : check && meta.filter.filter ? meta.filter.filter.profileID : null,
                score           : check && meta.filter.filter ? meta.filter.filter.score : [],
                sport           : check && meta.filter.filter ? meta.filter.filter.sport : undefined,
                level           : check && meta.filter.filter ? meta.filter.filter.level : undefined,
                gender          : check && meta.filter.filter ? meta.filter.filter.gender : undefined,
                range           : check && meta.filter.filter ? meta.filter.filter.range : undefined,
            },
            reloadNeeded: true,            
            failedTestSelectedOpt:  check && meta.failedTestOptions ? meta.failedTestOptions : []
        };
    }

    componentWillReceiveProps(nextProps: IFilterProps) {
        if (nextProps.organizations.length !== this.props.organizations.length) {
            var meta = SessionStorage.getReportMeta(),
               check = meta && meta.isTestLoaded && meta.filter.filter;
            this.setState({
                checkAll: check ? meta.filter.rosterids.length === nextProps.organizations.length : true,
                selectedOrgs: nextProps.organizations.map((v: any) => v.rosterid),
            });
        }
    }

    render() {
        return (
            <Card className="filterCard">
                <Row type="flex">
                    <Col className="filterHeader">
                        <span style={{color: 'red'}}>*</span>
                        {strings.isRangeTxt}
                    </Col>
                    <Col className="customBtnCol">
                        { this.isDesabledLoadBtn() ? 
                            <Tooltip placement="bottom" title={'Please select range to load report'}>
                                <Button 
                                    className="loadBtn" 
                                    disabled={this.isDesabledLoadBtn()}
                                    onClick={this.handleLoad}
                                >
                                    {strings.isLoadTxt}
                                </Button>
                            </Tooltip> : 
                            <Button 
                                className="loadBtn" 
                                disabled={this.isDesabledLoadBtn()}
                                onClick={this.handleLoad}
                            >
                                {strings.isLoadTxt}
                            </Button>
                        }
                    </Col>
                    <Col>&nbsp;&nbsp;</Col>
                    <Col>
                        <Button 
                            type="primary" 
                            disabled={!this.clearFilterNeeded()}
                            onClick={this.clearFilter}
                        >
                            {strings.isClrFilterTxt}
                        </Button>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <Radio.Group size="default" value={this.state.testRange} onChange={this.handleChange}>
                            <Radio.Button value="daily">{strings.isDailyTxt}</Radio.Button>
                            <Radio.Button value="monthly">{strings.isMonthlyTxt}</Radio.Button>
                            <Radio.Button value="yearly">{strings.isYearlyTxt}</Radio.Button>
                            <Radio.Button value="custom">{strings.isCustomTxt}</Radio.Button>
                        </Radio.Group>
                    </Col>
                </Row>
                <Row hidden={this.state.testRange !== 'custom'}>&nbsp;</Row>
                <Row hidden={this.state.testRange !== 'custom'}>
                    <DatePicker.RangePicker 
                        value={this.state.customRange}
                        onChange={this.handleDatePicker}
                        disabledDate={(current) => this.disabledDate(current)}
                    />
                </Row>
                <Row>&nbsp;</Row>
                <Row type="flex">
                    <Col className="filterCard-2-Row">
                        <Row className="filterHeader">
                            <span style={{color: 'red'}}>*</span>
                            {strings.isOrgTxt}
                        </Row>
                        <Row>{this.renderOrganizations()}</Row>
                    </Col>
                </Row>
                {
                this.props.isFailedTestFilterEnabled ? 
                <>
                    <Row>&nbsp;</Row>
                    <Row type="flex">
                        <Col className="filterHeader">                        
                            {strings.isAdditionaInformationTxt}
                        </Col>                    
                    </Row>                
                    <Row type="flex" className="allCheckRow">                   
                        <Checkbox
                            checked={this.state.failedTestSelectedOpt.length === 2}
                            onChange={(value) => {
                                this.onFailedTestOptionChange( value.target.checked ? 
                                            [FailedTestOptions.SHOW_TEST, FailedTestOptions.SHOW_BASELINE] 
                                            : [] );
                            }}
                        >{strings.isShowAllTxt}
                        </Checkbox>                    
                    </Row>
                    <Row className="checkRowBox">
                        <Col>
                            <Checkbox.Group 
                                options={[{label: strings.isShowFailedTest, value: FailedTestOptions.SHOW_TEST},
                                        {label: strings.isShowFailedBaseline, value: FailedTestOptions.SHOW_BASELINE}]} 
                                value={this.state.failedTestSelectedOpt}
                                onChange={this.onFailedTestOptionChange}
                            />
                        </Col>
                    </Row> 
                </> : null
                }
                <Row type="flex" hidden={this.state.collapsible}>
                    <FilterList 
                        hidden={this.hideAllCustoms()} 
                        custom={this.props.customState}
                    />
                </Row>
                <Row type="flex" hidden={!this.state.collapsible}>
                    <CustomFilter 
                        isPrivacyEnabled={false} 
                        custom={this.state.custom} 
                        setCustom={this.setCustom} 
                    />
                </Row>
                <Row>&nbsp;</Row>
                <Row hidden={!(this.state.testRange === 'custom')}>
                    <Button 
                        icon={this.state.collapsible ? 'minus' : 'plus'} 
                        type="primary"
                        onClick={this.handleCustomChange}
                    >
                        {this.state.collapsible ? strings.isLessTxt : strings.isMoreTxt}
                    </Button>
                </Row>
                {/* <Row type="flex" className="moreLessCol">
                    <Col className="moreLess" onClick={this.handleCustomChange} >
                        <Icon type={this.state.collapsible ? 'minus' : 'plus'} />
                    </Col>
                    <Col className="moreLess" onClick={this.handleCustomChange}>
                        {this.state.collapsible ? strings.isLessTxt : strings.isMoreTxt}
                    </Col>
                </Row> */}
            </Card>
        );
    }

    renderOrganizations = ( ) => {
        return (
            <>
                <Row type="flex" className="allCheckRow">
                    <Checkbox
                        indeterminate={this.state.indeterminate}
                        onChange={this.onCheckAllChange}
                        checked={this.state.checkAll}
                    >{strings.isAllTxt}
                    </Checkbox>
                </Row>
                <Row className="checkRowBox">
                    <Checkbox.Group 
                        options={this.createPlainArray(this.props.organizations)} 
                        value={this.state.selectedOrgs} 
                        onChange={this.onChange} 
                    />
                </Row>
            </>
        );
    }

    private getCustomRange = ({filter: {range}}) => 
        range && range.length > 0 ? [moment(range[0]), moment(range[1])] : []

    private handleLoad = async () => {
        var custom = this.state.custom;
        this.props.handleLoadCall(
            {
                testRange: this.state.testRange,
                rosterids: this.state.selectedOrgs,
                range: this.createRangeFromTxt(),
                failedTestOptions: this.state.failedTestSelectedOpt,
                filter: this.state.testRange === 'custom' ? 
                    {
                        ...this.state.custom,
                        score: (custom.score && 
                            (
                                custom.score.length === 2 && 
                                custom.score.every(
                                    v => v !== undefined && 
                                        v !== '' && 
                                        v.trim() !== '' && 
                                        /^\d+$/.test(v)  
                                )
                            )
                        ) ? 
                        custom.score : undefined
                    } : 
                    {}
            }, 
            () => this.setState({collapsible: false, reloadNeeded: false})
        );
    }   

    private createRangeFromTxt = () => {
        var s = this.state;
        if (s.testRange === 'monthly') {
            return [moment.utc(moment().startOf('M')).toString(), 
                    moment.utc(moment()).toString()];
        } else if (s.testRange === 'yearly') {
            return [moment.utc(moment().startOf('year')).toString(), 
                    moment.utc(moment()).toString()];
        } else if (s.testRange === 'custom') {
            return (s.customRange && s.customRange.length > 0) ? 
                    [moment.utc(s.customRange[0].startOf('d')), moment.utc(s.customRange[1].endOf('d'))] : [];
        } else {
            return [moment.utc(moment().subtract(1, 'd').startOf('d')).toString(),
                moment.utc(moment()).toString()];
        }
    }

    private isDesabledLoadBtn = () => {
        var s = this.state;
        return !( 
            s.testRange && 
            s.selectedOrgs.length > 0 && 
            (   s.testRange === 'custom' ? 
                (s.customRange && s.customRange.length > 0) : true 
            )
        ) || !this.state.reloadNeeded;
    }

    private createPlainArray = (organizations: Array<any>) => {
        return organizations.map((org) => (
            {label: (org.isprimary ? '*' : '') + org.name, value: org.rosterid}
        ));
    }

    private onChange = (selectedOrgs: Array<any>) => {
        this.setState({
            selectedOrgs,
            indeterminate: !!selectedOrgs.length && (selectedOrgs.length < this.props.organizations.length),
            checkAll: selectedOrgs.length === this.props.organizations.length,
            reloadNeeded: true
        });
    }

    private onFailedTestOptionChange = (selectedOptions: Array<any>) => {
        this.setState({
            failedTestSelectedOpt: selectedOptions,
            reloadNeeded: true
        });
    }

    private onCheckAllChange = (e: any) => {
        this.setState({
            selectedOrgs: e.target.checked ? 
                this.props.organizations.map((v: any) => v.rosterid) : 
                [],
            indeterminate: false,
            checkAll: e.target.checked,
            reloadNeeded: true
        });
    }

    private handleChange        = (e: any)          => this.setState({testRange: e.target.value, reloadNeeded: true});
    private handleDatePicker    = (value: any)      => this.setState({customRange: value, reloadNeeded: true});
    private handleCustomChange  = (e: any)          => this.setState({collapsible: !this.state.collapsible});
    private disabledDate        = (current: any)    => moment(current).startOf('day').isAfter(moment().startOf('d'));

    private setCustom = (obj: any) => {
        this.setState({
            custom: { 
                ...this.state.custom,
                ...obj
            },
            reloadNeeded: true
        });
    }

    private clearFilterNeeded = () => {
        var s = this.state;
        return (
            s.testRange || (s.selectedOrgs && s.selectedOrgs.length > 0 ) 
            || !(this.hideAllCustoms)
        );
    }

    private hideAllCustoms = () => {
        var keys = Object.keys(this.props.customState);
        for (var i = 0; i < keys.length; i++) {
            if (this.props.customState[keys[i]]) { return false; }
        }
        return true;
    }

    private clearFilter = () => {
        SessionStorage.clearReportMeta();
        this.setState (
            {
                testRange: '',
                selectedOrgs: this.props.organizations.map((v: any) => v.rosterid),
                customRange: [],
                indeterminate: false,
                checkAll: true,
                collapsible: false,
                failedTestSelectedOpt: [],
                custom: {
                    firstname       : null, 
                    lastname        : null,
                    middlename      : null,
                    profileID       : null,
                    score           : null,
                    sport           : undefined,
                    level           : undefined,
                    gender          : undefined,
                    range           : undefined,
                }
            }, 
            () => this.props.setParent({
                tests: [], 
                failedtests: [],
                filter: {rosterids: [], range: [], filter: {}, failedTestSelectedOpt: []},
                sort: {field: 'datetime', order: 'ascend'}
            })
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/reports/reports.filter.tsx